import ContactList from '@/components/admin/contacts/ContactList'
import ContactMessageSearch from '@/components/admin/contacts/ContactMessageSearch'
import ContactFilesList from '@/components/admin/contacts/ContactFilesList'
import ContactMassMessaging from '@/components/admin/contacts/ContactMassMessaging'
import ContactBulkOps from '@/components/admin/contacts/bulkops/ContactBulkOps'
import Contact from '@/components/admin/contacts/Contact'
import ContactImport from '@/components/admin/contacts/import/ContactImport.vue'
import auth from './../auth'

export default [
  {
    path: '/admin/contacts/list',
    name: 'ContactList',
    component: ContactList,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/admin/contacts/files',
    name: 'ContactFilesList',
    component: ContactFilesList,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/admin/contacts/bulkmail',
    name: 'ContactMassMessaging',
    component: ContactMassMessaging,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/admin/contacts/bulk',
    name: 'ContactBulkOps',
    component: ContactBulkOps,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/admin/contacts/messages',
    name: 'ContactMessageSearch',
    component: ContactMessageSearch,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/admin/contacts/import',
    name: 'ContactImport',
    component: ContactImport,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/admin/contacts/:id?/case/:case?',
    name: 'ContactCaseView',
    component: Contact,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/admin/contacts/:id?',
    name: 'Contact',
    component: Contact,
    beforeEnter: auth.ifAuthenticated
  }
]
